import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import { TokenStore } from './token-store.service';
import { TokenPair, CustomerLoginPayload } from './models';

@Injectable({ providedIn: 'root' })
export class CustomerAuthService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);
  private tokens = inject(TokenStore);

  async login(payload: CustomerLoginPayload): Promise<TokenPair> {
    const res = await firstValueFrom(
      this.http.post<TokenPair>(this.api.url('v1/customer/auth/login/'), payload),
    );
    this.tokens.setCustomerTokens(res.access, res.refresh);
    return res;
  }

  async refresh(): Promise<TokenPair | null> {
    const refresh = this.tokens.getCustomerRefresh();
    if (!refresh) return null;
    try {
      const res = await firstValueFrom(
        this.http.post<TokenPair>(this.api.url('v1/customer/auth/refresh/'), { refresh }),
      );
      this.tokens.setCustomerTokens(res.access, res.refresh ?? refresh);
      return res;
    } catch {
      this.tokens.clearCustomer();
      return null;
    }
  }

  logout(): void {
    this.tokens.clearAll();
  }

  isAuthenticated(): boolean {
    const access = this.tokens.getCustomerAccess();
    if (!access) return false;
    return !this.tokens.isExpired(access);
  }
}
